import { SearchBar } from "./search-bar";
import { SearchDropdown } from "./search-dropdown";

/**
 * SearchCombo Component
 * STRICT RULE: Pure UI only - no business logic, no external system calls
 * Combines search bar and dropdown into a single component
 */

interface SearchComboProps {
  className?: string;
  placeholder?: string;
}

export function SearchCombo({
  className = "",
  placeholder = "Search...",
}: SearchComboProps) {
  return (
    <div className={`relative ${className}`}>
      <SearchBar placeholder={placeholder} />
      <SearchDropdown />
    </div>
  );
}
